// A little parametric panda face drawn as inline SVG. `mood` (0 = sad .. 1 =
// happy) curves the mouth from a frown to a smile, lowers the gaze and adds a
// tear when sad, and adds rosy cheeks + bright eyes when happy. Used for the
// mood-o-meter end caps and the results screen.

export function pandaFaceSVG(mood: number, size = 40): string {
  const m = Math.max(0, Math.min(1, mood));
  const k = -9 + m * 22; // mouth control: frown -> smile
  const tear = Math.max(0, (0.28 - m) / 0.28); // tear only when quite sad
  const cheek = Math.max(0, (m - 0.55) / 0.45); // cheeks only when quite happy
  const pupilY = 51.5 - m * 2.5; // gaze lifts as mood rises
  const highlight = 0.9 + m * 0.7;

  return `<svg width="${size}" height="${size}" viewBox="0 0 100 100" aria-hidden="true">
    <circle cx="26" cy="24" r="14" fill="#1e1e1e"/>
    <circle cx="74" cy="24" r="14" fill="#1e1e1e"/>
    <circle cx="26" cy="24" r="6" fill="#3a342f"/>
    <circle cx="74" cy="24" r="6" fill="#3a342f"/>
    <circle cx="50" cy="55" r="35" fill="#f4f4f1" stroke="#d6d6cf" stroke-width="1.5"/>
    <ellipse cx="37" cy="52" rx="12" ry="15.5" fill="#1e1e1e" transform="rotate(22 37 52)"/>
    <ellipse cx="63" cy="52" rx="12" ry="15.5" fill="#1e1e1e" transform="rotate(-22 63 52)"/>
    <circle cx="33" cy="74" r="6.5" fill="#ff9bb0" opacity="${(cheek * 0.85).toFixed(2)}"/>
    <circle cx="67" cy="74" r="6.5" fill="#ff9bb0" opacity="${(cheek * 0.85).toFixed(2)}"/>
    <circle cx="38" cy="51" r="6" fill="#ffffff"/>
    <circle cx="62" cy="51" r="6" fill="#ffffff"/>
    <circle cx="38" cy="${pupilY.toFixed(1)}" r="3.4" fill="#141414"/>
    <circle cx="62" cy="${pupilY.toFixed(1)}" r="3.4" fill="#141414"/>
    <circle cx="39.4" cy="${(pupilY - 1.4).toFixed(1)}" r="${highlight.toFixed(2)}" fill="#ffffff"/>
    <circle cx="63.4" cy="${(pupilY - 1.4).toFixed(1)}" r="${highlight.toFixed(2)}" fill="#ffffff"/>
    <ellipse cx="50" cy="64" rx="5" ry="3.4" fill="#1a1a1a"/>
    <path d="M40 72 Q50 ${(72 + k).toFixed(1)} 60 72" fill="none" stroke="#1a1a1a" stroke-width="2.6" stroke-linecap="round"/>
    <path d="M31 58 q-2.2 5 -0.2 8.5 q2.4 -3 0.2 -8.5 z" fill="#6fb7ff" opacity="${tear.toFixed(2)}"/>
  </svg>`;
}

/** A short label for the panda's final mood. */
export function moodLabel(mood: number): string {
  if (mood >= 0.78) return 'Over the moon!';
  if (mood >= 0.58) return 'Happy panda';
  if (mood >= 0.42) return 'Content panda';
  if (mood >= 0.22) return 'A bit glum';
  return 'Sad panda';
}
